// src/lib/trainingFollowupApi.js
import { callAi } from "./geminiClient";

function buildResources(lang) {
  if (lang === "zh-CN") {
    const clinicInfo = `
${process.env.REACT_APP_CN_CLINIC_NAME} 信息
- 地址: 首尔市江南区德黑兰路109号，10楼 (驿三洞，江南第一大厦)
- 电话号码: 02-501-2120
- 诊疗科目: 仅专注减肥专业诊疗
- 诊疗特征:
    - 20年经验，全国34家分店
    - 可非面对面减肥韩药处方
    - 平日每日夜间诊疗，周六诊疗
- 代表项目:
    - ${process.env.REACT_APP_CN_JIBANG_SAYACK}: 胶囊形态，携带方便。2周药 5万韩元起。
    - ${process.env.REACT_APP_CN_SIKTAM_SAYAK}: 汤剂形态，吸收率高，12阶段定制处方。1个月 28万韩元起。
    - 辅助胶囊: ${process.env.REACT_APP_CN_JIBANG_KILL}(内脏脂肪), ${process.env.REACT_APP_CN_DOKSO_KILL}(体质改善), ${process.env.REACT_APP_CN_SUMYEON_KILL}(睡眠中燃烧体脂)
- 代表院长: 曾任江南/狎鸥亭诊疗院长，20年以上减肥诊疗经验
- 评价: 平均评分 4.9以上，对亲切的医疗团队和减肥效果满意度高。
`.trim();

    return {
      clinicInfo,
      prompts: {
        assistant: `你是 '${process.env.REACT_APP_CN_CLINIC_NAME}' 的资深咨询组长，金孝静。你的目标是与患者建立长期的信任关系，不执着于一次性销售。你的语气非常专业，同时温暖且富有同理心。请务必基于下方提供的 [韩医院信息] 编写回答。

[韩医院信息]
${clinicInfo}

[患者情况]
患者接受了初期减肥咨询，但因 '{concernType}' 还在犹豫最终决定。{patientNotes?}

[请求事项]
请编写发给该患者的后续短信(SMS)草案，使用亲切的'敬语体(请用亲切、柔和的敬语回答。)'。信息的目的是让患者安心，并表明充分理解患者的烦恼。绝对不能给人强迫购买的感觉。相反，要传达真心为患者健康着想，并随时准备回答追加问题的心意。信息末尾请务必包含你的名字和职位。(例: ${process.env.REACT_APP_CN_CLINIC_NAME} 金孝静 咨询组长 敬上)

[编写指南]
- 请将共鸣患者的烦恼放在首位。
- 不要只重复提及韩医院的历史(20年经验)。
- 而是根据情况自然地利用以下多种依据给予信任:
  - **众多好评:** '像许多满意的顾客一样...'
  - **院长的专业性:** '在江南、狎鸥亭积累丰富经验的院长...'
  - **定制型项目:** '细分为12阶段的定制处方' 或 '携带方便的胶囊型' 等提及项目优点。
  - **诊疗便利性:** '每日夜间诊疗' 或 '非面对面诊疗' 等强调符合患者情况的优点。`,
        outreach: `你是 '${process.env.REACT_APP_CN_CLINIC_NAME}' 的首席咨询组长 金孝静。你最看重的是与患者建立信任关系而非销售。语气非常亲切、共情，且不失专业性。请务必基于下方提供的 [韩医院信息] 编写回答。

[韩医院信息]
${clinicInfo}

[情况]
今天以 '{theme}' 为主题，打算给以前咨询过但这还没开始治疗的潜在患者打电话。{profile?}

[请求事项]
请编写符合此情况的自然电话咨询开场脚本，使用亲切的'敬语体(请用亲切、柔和的敬语回答。)'。脚本需遵循以下结构:
1. 温柔的问候和自我介绍
2. 自然连接问候和通话目的
3. 引出患者当前情况或烦恼的开放式提问
4. 不强迫，舒适地延续下一次对话的结尾`,
        plan: `你是 '${process.env.REACT_APP_CN_CLINIC_NAME}' 的首席健康顾问。你是尊重患者的生活方式，同时建议可行且有效的健康计划的专家。语气给予信任感的同时非常温暖和鼓舞人心。请务必基于下方提供的 [韩医院信息] 编写回答。

[韩医院信息]
${clinicInfo}

[患者资料]
{profile}

[请求事项]
基于上述患者资料，请编写以 '{focus}' 为重点的 '定制健康计划' 草案，使用亲切的'敬语体(请用亲切、柔和的敬语回答。)'。此计划需包含基于韩医学知识的专业建议。请以 **"### 饮食建议"** / **"### 生活习惯建议"** 두 파트로 Markdown 작성，并自然提及 '${process.env.REACT_APP_CN_JIBANG_SAYACK}/${process.env.REACT_APP_CN_SIKTAM_SAYAK}/辅助胶囊' 等。`
      },
      ui: {
        mustLogin: "请先登录后再使用。",
      },
    };
  }

  // 한국어(기본)
  const clinicInfo = `
${process.env.REACT_APP_CLINIC_NAME} 정보
- 위치: 서울시 강남구 테헤란로 109, 10층(역삼동, 강남제일빌딩)
- 전화번호: 02-501-2120
- 진료 과목: 오직 다이어트만 전문 진료
- 진료 특징:
    - 20년 노하우, 전국 34개 지점
    - 비대면 다이어트 한약 처방 가능
    - 평일 매일 야간진료, 토요일 진료
- 대표 프로그램:
    - ${process.env.REACT_APP_JIBANG_SAYACK}: 캡슐 형태, 휴대 용이. 2주 약 5만원부터.
    - ${process.env.REACT_APP_SIKTAM_SAYAK}: 탕제 형태, 흡수율 높음, 12단계 맞춤 처방. 1개월 28만원부터.
    - 보조캡슐: ${process.env.REACT_APP_JIBANG_KILL}(내장지방), ${process.env.REACT_APP_DOKSO_KILL}(체질개선), ${process.env.REACT_APP_SUMYEON_KILL}(수면 중 체지방 연소)
- 대표원장: 강남/압구정 진료원장 역임, 20년 이상 다이어트 진료 경험
- 후기: 평균 평점 4.9 이상, 친절한 의료진과 다이어트 효과에 대한 만족도 높음.
`.trim();

  return {
    clinicInfo,
    prompts: {
      assistant: `당신은 '${process.env.REACT_APP_CLINIC_NAME}'의 베테랑 상담팀장, 김효정이에요. 반드시 아래 [한의원 정보]를 기반으로 답변하세요.

[한의원 정보]
${clinicInfo}

[환자 상황]
환자는 초기 다이어트 상담을 받았지만, '{concernType}' 때문에 최종 결정을 망설이고 있어요.{patientNotes?}

[요청사항]
환자에게 보낼 후속 문자(SMS) 초안을 '해요체'로 작성해주세요. 강요 금지, 공감/안심 우선. 마지막에 이름과 직책 포함(예: ${process.env.REACT_APP_CLINIC_NAME} 김효정 상담팀장 드림).

[작성 가이드]
- 고민 공감 최우선
- 20년 역사 반복 X
- 상황에 맞춰 신뢰 근거 활용(후기/전문성/맞춤형/진료편의성 등)`,
      outreach: `당신은 '${process.env.REACT_APP_CLINIC_NAME}'의 최고 상담팀장 김효정이에요. 아래 [한의원 정보]를 기반으로 답변하세요.

[한의원 정보]
${clinicInfo}

[상황]
오늘은 '{theme}'을(를) 주제로, 이전 문의자(치료 미시작)에게 전화를 드리려 해요.{profile?}

[요청사항]
자연스러운 '통화 시작 스크립트'를 해요체로. 구조:
1) 인사/자기소개
2) 안부 + 통화 목적 자연 연결
3) 현재 상황/고민을 이끌어내는 개방형 질문
4) 강요 없이 다음 대화로 이어지는 마무리`,
      plan: `당신은 '${process.env.REACT_APP_CLINIC_NAME}'의 수석 건강 컨설턴트예요. 아래 [한의원 정보]를 기반으로 답변하세요.

[한의원 정보]
${clinicInfo}

[환자 프로필]
{profile}

[요청사항]
'{focus}'에 중점을 둔 '맞춤 건강 플랜' 초안을 해요체로. '### 식단 제안' / '### 생활 습관 제안' 두 파트로 Markdown 작성. '${process.env.REACT_APP_JIBANG_SAYACK}/${process.env.REACT_APP_SIKTAM_SAYAK}/보조캡슐'을 자연스럽게 언급.`
    },
    ui: {
      mustLogin: "로그인 후 사용해 주세요",
    },
  };
}

/** 공통: 로그인 확인 */
function ensureLoginOrThrow(lang) {
  const userStr = (typeof localStorage !== "undefined" && localStorage.getItem("user")) || "";
  const user = userStr ? JSON.parse(userStr) : null;
  if (!user) {
    alert(lang === "zh-CN" ? "请先登录后再使用。" : "로그인 후 사용해 주세요");
    if (typeof window !== "undefined") window.location.href = "/login";
    throw new Error("NOT_AUTHENTICATED");
  }
  return user;
}

function getLang() {
  return (typeof document !== "undefined" && document.documentElement?.lang) || "ko";
}

export const TrainingFollowupAI = {
  /** 1) 상담 후속 문자 생성 */
  async message({ concernType, patientNotes }) {
    const lang = getLang();
    const { prompts } = buildResources(lang);
    const user = ensureLoginOrThrow(lang);

    const prompt = prompts.assistant
      .replace("{concernType}", concernType || "")
      .replace("{patientNotes?}", patientNotes ? ` 환자에 대한 추가 정보: "${patientNotes}"` : "");

    const contents = [{ role: "user", parts: [{ text: prompt }] }];
    const data = await callAi({
      contents,
      api_name: "counsel_training_followup",
      userId: user.id,
      generationConfig: null,
      version: undefined,
    });
    const answer = data?.data?.answer ?? data?.answer ?? data?.text ?? data?.data?.text;
    if (!answer) throw new Error("응답 형식이 올바르지 않습니다.");
    return { answer };
  },

  /** 2) 아웃리치(재문의) 콜 오프닝 스크립트 */
  async outreach({ theme, profile }) {
    const lang = getLang();
    const { prompts } = buildResources(lang);
    const user = ensureLoginOrThrow(lang);

    const prompt = prompts.outreach
      .replace("{theme}", theme || "")
      .replace("{profile?}", profile ? ` 타겟 프로필: "${profile}"` : "");

    const contents = [{ role: "user", parts: [{ text: prompt }] }];
    const data = await callAi({
      contents,
      api_name: "counsel_training_followup",
      userId: user.id,
      generationConfig: null,
      version: undefined,
    });
    const answer = data?.data?.answer ?? data?.answer ?? data?.text ?? data?.data?.text;
    if (!answer) throw new Error("응답 형식이 올바르지 않습니다.");
    return { answer };
  },

  /** 3) 맞춤 건강 플랜 */
  async plan({ focus, profile }) {
    const lang = getLang();
    const { prompts } = buildResources(lang);
    const user = ensureLoginOrThrow(lang);

    const prompt = prompts.plan
      .replace("{focus}", focus || "")
      .replace("{profile}", profile || "");

    const contents = [{ role: "user", parts: [{ text: prompt }] }];
    const data = await callAi({
      contents,
      api_name: "counsel_training_followup",
      userId: user.id,
      generationConfig: null,
      version: undefined,
    });
    const answer = data?.data?.answer ?? data?.answer ?? data?.text ?? data?.data?.text;
    if (!answer) throw new Error("응답 형식이 올바르지 않습니다.");
    return { answer };
  },
};
